import { Masonry, Spin, Splitter } from 'antd'
import React, { useEffect, useState } from 'react'
import { get } from '../../Common/api'
import Selectors from './Selectors'
import dayjs from 'dayjs'
import MultipleBoxCharts from './MulitipleBoxCharts'
import SingleBoxCharts from './SingleBoxCharts'

export default function BoxStatistics ({ boxes }) {
  const [filter, setFilter] = useState({
    start_date: dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end_date: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    box_ids: boxes.map((box) => box.id)
  })
  const [appointments, setAppointments] = useState()
  const [loading, setLoading] = useState(false)

  const getData = async () => {
    setLoading(true)
    await get({
      url: 'admin/statistics',
      params: filter,
      onSuccess: (json) => {
        setAppointments(json.appointments)
        setLoading(false)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (filter) {
      getData()
    }
  }, [filter])

  const displayedCharts = (selectedBoxes, appointments) => {
    if (selectedBoxes.length > 1) {
      return MultipleBoxCharts(appointments, selectedBoxes)
    } else {
      return SingleBoxCharts(appointments, selectedBoxes[0])
    }
  }

  return (
    <Splitter orientation='vertical' style={{ height: '85vh' }}>
      <Splitter.Panel collapsible={{ start: true, end: true, showCollapsibleIcon: true }} max='30%'>
        <Selectors setFilter={setFilter} />
      </Splitter.Panel>
      <Splitter.Panel>
        <Spin spinning={loading}>
          { appointments && boxes && <Masonry gutter={16} items={displayedCharts(filter.box_ids, appointments)} /> }
        </Spin>
      </Splitter.Panel>
    </Splitter>
  )
}
